import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { Routing } from "../../../../core/routing";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { clientEditFormValidation, IClient, IClientForm } from "../../data/entities";
import { ClientForm } from "../components/form";
import { clientRedux } from "../state/state";

export const ClientEditPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const id = match.params.id;
  const dispatch = useDispatch();
  const history = useHistory();

  const clientDetailBranch = useSelector<IAppReduxState, IAsyncData<IClient>>((state) => state.client.details);
  const editClientBranch = useSelector<IAppReduxState, IAsyncData<void>>((state) => state.client.edit);

  useEffect(() => {
    dispatch(clientRedux.actions.getDetail(id));
  }, [dispatch, id]);

  const onSubmit = async (form: IClientForm): Promise<void> => {
    await dispatch(clientRedux.actions.edit(id, form));
    history.push(Routing.generateDetailRoute(ROUTES.client, id));
  };

  return (
    <ClientForm
      initialData={clientDetailBranch}
      onSubmit={onSubmit}
      branch={editClientBranch}
      validationSchema={clientEditFormValidation}
      submitTitle="Edit"
    />
  );
};
